import { useEffect } from "react";
import { createFileRoute, Navigate, useNavigate } from "@tanstack/react-router";

import { AppProvider } from "~/providers/app-provider";
import { ModuleProvider } from "~/providers/module-provider";
import { UserProvider } from "~/providers/user-provider";
import { useAuthStore } from "~/stores/use-auth-store";
import { usePreferencesStore } from "~/stores/use-preferences-store";

export const Route = createFileRoute("/_main")({
  component: MainLayout,
});

function MainLayout() {

  const { homePage } = usePreferencesStore();

  const navigate = useNavigate();

  const { session, sessionChecked } = useAuthStore();

  useEffect(() => {
    if (window.location.pathname === "/") {
      void navigate({ to: homePage });
    }
  }, [homePage, navigate]);

  if (!session && !sessionChecked) {
    return null;
  }

  if (!session && sessionChecked) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex flex-col h-[100dvh] w-[100dvw] relative overflow-hidden">
      <ModuleProvider>
        <UserProvider>
          <AppProvider />
        </UserProvider>
      </ModuleProvider>
    </div>
  );
}
